(function () {
  console.log('[InventoryBadge] script loaded');

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-inventory-gallery-badge-close]');
    if (!closeBtn) return;
    var badge = closeBtn.closest('[data-inventory-gallery-badge]');
    if (badge) badge.classList.add('is-dismissed');
  });

  var productInfo = document.querySelector('product-info[data-section][data-url]');
  if (!productInfo) {
    console.warn('[InventoryBadge] product-info element not found');
    return;
  }

  var sectionId = productInfo.dataset.section;
  var productUrl = productInfo.dataset.url;

  function swapBadge(doc) {
    var destination = document.getElementById('InventoryGalleryBadge-' + sectionId);
    var source = doc.getElementById('InventoryGalleryBadge-' + sectionId);
    console.log('[InventoryBadge] destination:', !!destination, '| source:', !!source);
    if (!destination) return;
    destination.innerHTML = source ? source.innerHTML : '';
  }

  function fetchAndSwap(variantId) {
    console.log('[InventoryBadge] fetching for variant:', variantId);
    fetch(productUrl + '?variant=' + variantId + '&section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        swapBadge(doc);
      })
      .catch(function (err) {
        console.error('[InventoryBadge] fetch error:', err);
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event.data.sectionId !== sectionId) return;
      console.log('[InventoryBadge] pub/sub variant change:', event.data.variant.id);
      swapBadge(event.data.html);
    });
  }

  var lastVariant = new URLSearchParams(window.location.search).get('variant');

  function checkUrl() {
    var current = new URLSearchParams(window.location.search).get('variant');
    if (current && current !== lastVariant) {
      lastVariant = current;
      console.log('[InventoryBadge] URL variant changed to:', current);
      fetchAndSwap(current);
    }
  }

  setInterval(checkUrl, 500);
  window.addEventListener('popstate', function () {
    setTimeout(checkUrl, 100);
  });
})();
